import { useEffect, useRef, useState } from 'react';
import { makeApiRequest, RequestStatus } from '../../api_request/api_request';
import { useAppDispatch } from '../../store/hooks';
import { RequestStatusDisplay } from '../CommonComponents';
import { GetPageTitle } from '../../ErnotsConfig';
import { useLocation } from 'react-router-dom';

export function UserActivationForm()
{
    const appDispatch = useAppDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const uid = searchParams.get('uid');
    const token = searchParams.get('token');

    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);
    
    //This prevents the request from being sent twice as a result of React's Strict Mode behavior.
    const isActivatingRef = useRef(false);

    useEffect(function()
    {
        if (uid && token && !isActivatingRef.current)
        {
            const userData = {uid, token};
            makeApiRequest({
                endpoint: 'users/activation/',
                method: 'POST',
                postData: userData,
                dispatch: appDispatch,
                lifeCycleCallback: setRequest,
                useAuthPrefix: true
            });
            isActivatingRef.current = true;
        }
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uid, token]);

    const ret = (
        <div>
            <h3>Attempting to activate account</h3>
            {(uid && token)
                ? <RequestStatusDisplay request={request}/>
                : <>Invalid activation URL</>}
        </div>
    );

    return (
    <div className='ernots_User ernots_UserActivationForm'>
        <title>{GetPageTitle('User Activation Form')}</title>
        {ret}
    </div>);
};